import { useContext } from 'react';
import { PaybackClientContext } from './PaybackClientContext';

export const usePaybackClient = () => useContext(PaybackClientContext);
